"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunsFields = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_panel_1 = require("../../../composite/form/fields/form-panel");
const form_select_1 = require("../../../composite/form/fields/form-select");
const schedule_api_1 = require("../schedule-api");
const form_date_time_field_1 = require("../../../composite/form/fields/form-date-time-field");
const form_text_area_1 = require("../../../composite/form/fields/form-text-area");
function RunsFields() {
    const intl = react_intl_1.useIntl();
    const jobs = schedule_api_1.useJobs();
    const states = schedule_api_1.useRunStates();
    return (react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_SCHEDULE_RUNS_PANEL_TITLE", defaultMessage: "B\u011Bh \u010Dasov\u00E9 \u00FAlohy" }) },
        react_1.default.createElement(form_select_1.FormSelect, { name: "job", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_SCHEDULE_RUNS_FIELD_LABEL_JOB", defaultMessage: "\u00DAloha" }), helpLabel: intl.formatMessage({
                id: 'EAS_SCHEDULE_RUNS_FIELD_HELP_JOB',
                defaultMessage: ' ',
            }), source: jobs, tooltipMapper: (o) => o.name }),
        react_1.default.createElement(form_select_1.FormSelect, { name: "state", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_SCHEDULE_RUNS_FIELD_LABEL_STATE", defaultMessage: "Stav" }), helpLabel: intl.formatMessage({
                id: 'EAS_SCHEDULE_RUNS_FIELD_HELP_STATE',
                defaultMessage: ' ',
            }), source: states, tooltipMapper: (o) => o.name, valueIsId: true }),
        react_1.default.createElement(form_date_time_field_1.FormDateTimeField, { name: "startTime", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_SCHEDULE_RUNS_FIELD_LABEL_START_TIME", defaultMessage: "Za\u010D\u00E1tek" }), helpLabel: intl.formatMessage({
                id: 'EAS_SCHEDULE_RUNS_FIELD_HELP_START_TIME',
                defaultMessage: ' ',
            }) }),
        react_1.default.createElement(form_date_time_field_1.FormDateTimeField, { name: "endTime", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_SCHEDULE_RUNS_FIELD_LABEL_END_TIME", defaultMessage: "Konec" }), helpLabel: intl.formatMessage({
                id: 'EAS_SCHEDULE_RUNS_FIELD_HELP_END_TIME',
                defaultMessage: ' ',
            }) }),
        react_1.default.createElement(form_text_area_1.FormTextArea, { name: "result", disabled: true, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_SCHEDULE_RUNS_FIELD_LABEL_RESULT", defaultMessage: "V\u00FDsledek" }), helpLabel: intl.formatMessage({
                id: 'EAS_SCHEDULE_JOBS_FIELD_HELP_RESULT',
                defaultMessage: ' ',
            }) }),
        react_1.default.createElement(form_text_area_1.FormTextArea, { name: "console", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_SCHEDULE_RUNS_FIELD_LABEL_CONSOLE", defaultMessage: "Konzole" }), helpLabel: intl.formatMessage({
                id: 'EAS_SCHEDULE_JOBS_FIELD_HELP_CONSOLE',
                defaultMessage: ' ',
            }) })));
}
exports.RunsFields = RunsFields;
//# sourceMappingURL=runs-fields.js.map